let _ = require('ES/lib/lodash');
let dateformat = require('ES/lib/dateformat');
let getResultDates = require('./getResultDates');

module.exports = function (results) {
  let results_w_date = _.flattenDeep(_.map(results, function (result) {
    let dates = getResultDates(result);
    if (_.isEmpty(dates)) {
      return result;
    }
    return _.map(dates, function (date) {
      return _.assign({}, result, {
        this_result_date: date
      });
    });
  }));

  let results_by_date = _.groupBy(results_w_date, function (result) {
    let d = result.this_result_date;
    return _.isDate(d)
      ? dateformat(d, 'mmmm yyyy')
      : 'Dateless Events';
  });

  return _.mapValues(results_by_date, function (results, group_name) {
    let results_by_sid = {};
    let push = function (sid, result) {
      if (!_.has(results_by_sid, sid)) {
        results_by_sid[sid] = [];
      }
      results_by_sid[sid].push(result);
    };
    _.each(results, function (result) {
      if (_.size(result && result.sids) > 0) {
        _.each(result && result.sids, function (sid) {
          push(sid, result);
        });
      } else {
        push('no-sids', result);
      }
    });
    return results_by_sid;
  });
};



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/TreeSearch/searchResultsToTree.js